'use strict';

const $waitingPages = $('.waiting_page');
const trackingUtils = require('./../utils/tracking.utils');
const xsellController = import(/* webpackChunkName: "module-xsell" */ 'od-modules/xsell/controller');
const appContext = require('od-modules/xsell/config/app_context');
const postBookingUtils = require('../utils/post_booking.utils');
const xsellUtils = require('od-modules/xsell/utils');
const tripdetailsStorageUtils = require('../utils/tripdetails_storage.utils');
const membershipRepository = require('od-modules/xsell/repositories/membership_repository');
const deeplinkBuilder = require('od-modules/xsell/deeplinks/deeplinks');
const hotelLabels = require('od-modules/xsell/config/hotel_touchpoint_labels');
const MULTI = 'MULTI';
const PREMIUM = 'PREMIUM';
const BOOKING_INFO = 'bookingInfo';

let linkExpiredFlag = false;
let isAccommodationPostBookingCoSearch = false;
let travelCompanionResponse;

const widgets = Odigeo.autoloadWidgetsAsync({
    getUsersManager: ['users-manager', 'usersmanager'],
    getPostBookingAccommodation: ['post-booking-accommodation', 'post_booking_accommodation'],
    getAccommodationSearchManager: ['accommodation-search-post-booking', 'accommodation_search_manager'],
    getMembershipManager: ['membership-manager', 'membership_manager'],
});

function replaceCIDForPrimeCID(wapb3) {
    const wapb3Parts = wapb3.split('|');
    wapb3Parts[1] = Odigeo.CrossSelling.expedia.expediaWab3IdPrime;
    return wapb3Parts.join('|');
}

function trackRedirectionReason({
    isLinkExpired,
    isMultiDestination,
    bookingStatusIssue,
    hasDP,
    siteIssue,
    hasManyPassengers,
    primeIssue,
}) {
    let reasonRedirection;

    if (isLinkExpired) {
        reasonRedirection = 'link_expired';
    } else if (isMultiDestination) {
        reasonRedirection = 'multi_destination';
    } else if (bookingStatusIssue) {
        reasonRedirection = 'booking_status_issue';
    } else if (hasDP) {
        reasonRedirection = 'has_dp';
    } else if (siteIssue) {
        reasonRedirection = 'site_issue';
    } else if (hasManyPassengers) {
        reasonRedirection = 'has_many_passengers';
    } else if (primeIssue) {
        reasonRedirection = 'membership_issue';
    }
    trackingUtils.trackEvent('accommodation_postbooking_on_load', `postbook_redirect_white_label_${reasonRedirection}`);
}

function shouldRedirectToWhiteLabel(data) {
    const {accommodationPostBookingPrime, accommodationPostBookingAll} = getAccommodationPostBookingConfig();
    const redirectPerRules = shouldRedirectPerRules(data, accommodationPostBookingPrime);
    return (!accommodationPostBookingPrime && !accommodationPostBookingAll) || redirectPerRules;
}

function getAccommodationPostBookingConfig() {
    const {
        getAccommodationPostBooking,
        getAccommodationPostBookingMobile,
    } = Odigeo.AB;
    const accommodationPostBookingPrime = getAccommodationPostBooking === 2 || getAccommodationPostBookingMobile === 2;
    const accommodationPostBookingAll = getAccommodationPostBooking === 3 || getAccommodationPostBookingMobile === 3;
    return {accommodationPostBookingPrime, accommodationPostBookingAll};
}

function shouldRedirectPerRules({bookingDetailDTO}, accommodationPostBookingPrime) {
    const isLinkExpired = postBookingUtils.hasExpiredDepartureDay(bookingDetailDTO);
    const hasDP = !Odigeo._.isNull(bookingDetailDTO.accommodationBooking);
    const itineraryBookingsType = bookingDetailDTO.itineraryBookings.bookingItinerary.tripType;
    const isMultiDestination = itineraryBookingsType.substring(0, 5) === MULTI;
    const siteIssue = bookingDetailDTO.bookingBasicInfo.website.code !== Odigeo.SessionScope.website;
    const VALID_BOOKING_STATUS = ['CONTRACT', 'REQUEST'];
    const bookingStatusIssue = !(VALID_BOOKING_STATUS.includes(bookingDetailDTO.bookingStatus));
    const hasManyPassengers = bookingDetailDTO.travellers.length > 4;
    const primeIssue = accommodationPostBookingPrime && !membershipRepository.isPrimeUser();

    const shouldRedirectRules = isLinkExpired ||
        hasDP ||
        isMultiDestination ||
        siteIssue ||
        bookingStatusIssue ||
        hasManyPassengers ||
        primeIssue;

    if (shouldRedirectRules) {
        if (isLinkExpired) {
            linkExpiredFlag = true;
        }
        trackRedirectionReason({
            isLinkExpired,
            isMultiDestination,
            bookingStatusIssue,
            hasDP,
            siteIssue,
            hasManyPassengers,
            primeIssue,
        });
    }
    return shouldRedirectRules;
}

module.exports = {
    viewEvents: {
        'post-booking:loadTrip': 'onLoadTrip',
        'post-booking-accommodation:available': 'onAvailableAccommodationPostBooking',
        'post-booking-accommodation:loadError': 'onAccommodationPostBookingError',
        'accommodation-search-post-booking:successPostBookingAccommodationSearch': 'onSuccessPostBookingAccommodationSearch',
        'accommodation-search-post-booking:errorNewAccommodationSearch': 'onErrorPostBookingAccommodationSearch',
        'users-manager:getTripOk': 'onTripLoadOk',
        'post-booking:noParams': 'onTripLoadOk',
        'post-booking:getTripFromSessionOk': 'onTripLoadOk',
        'users-manager:getTripWithError': 'onTripLoadError',
        'users-manager:getTripError': 'onTripLoadError',
        'post-booking-accommodation-view:specialErrors': 'onWLRedirectionErrors',
        'membership-manager:getUserTypeOk': 'onGetUserTypeResponseOk',
        'membership-manager:getUserTypeFail': 'onGetUserTypeResponseError',
        'post-booking:launchHomeCoSearch': 'onLaunchHomeCoSearch',
    },

    eventHandlers: {
        onLoadTrip: function(data) {
            widgets.getUsersManager().execute('submitUserRequest', data);
        },
        onAvailableAccommodationPostBooking: function(searchParams) {
            widgets.getAccommodationSearchManager().execute('postBooking', searchParams, false);
        },
        onAccommodationPostBookingError: function() {
            trackingUtils.trackPage('results_error', {funnel: 'hotels'});
        },
        onErrorPostBookingAccommodationSearch: function() {
            widgets.getPostBookingAccommodation().execute('error', 'no_hotel_results');
        },
        onSuccessPostBookingAccommodationSearch: function(data) {
            Odigeo.Session.set('intPageAccommodationResults', JSON.stringify(data));
            if (!Odigeo._.isEmpty(data.errors)) {
                this.trackErrorAndMessages(data.errors, 'hotelpostbooking-noavailable_');
                widgets.getPostBookingAccommodation().execute('error', 'no_hotel_results');
            } else if (!Odigeo._.isEmpty(data.messages) || data.accommodationSearchResultsMetadata.numResults < 1) {
                this.trackErrorAndMessages(data.messages, 'hotelpostbooking-noavailable_');
                widgets.getPostBookingAccommodation().execute('error', 'no_hotel_results');
            } else {
                trackingUtils.trackEvent('intermediate_page_on_load', 'intermediate_page_shown_postBooking');
                if (data.analyticsSearchInfo) {
                    Odigeo.Session.set('analyticsSearchInfo', JSON.stringify(data.analyticsSearchInfo));
                }
                this.goToIntermediatePage();
            }
        },

        goToIntermediatePage: function() {
            const params = isAccommodationPostBookingCoSearch ? 'isAccommodationPostBookingCoSearch=true;' : '';
            const url = 'xsellproductselection';
            xsellUtils.navigateToNonSecure(url, params);
        },

        onTripLoadOk: function(data) {
            if (data.bookingDetailDTO) {
                tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, data.bookingDetailDTO);
                if (data.isAccommodationPostBookingCoSearch) {
                    data.hasPrimeDiscount = membershipRepository.isPrimeUser();
                    this.redirectToPostBookingFunnel(data);
                } else {
                    this.checkIfUserIsPrime(data);
                }
            } else {
                widgets.getPostBookingAccommodation().execute('error', 'no_booking_found');
                postBookingUtils.errorHotelsHomeRedirection();
            }
        },

        checkIfUserIsPrime: function(data) {
            travelCompanionResponse = data;
            widgets.getMembershipManager().execute('getUserType', data.bookingDetailDTO.buyer.mail);
        },

        redirectToPostBookingFunnel: function(data) {
            if (shouldRedirectToWhiteLabel(data)) {
                this.goToWhiteLabel(data);
            } else {
                this.goToOwnFunnel(data);
            }
        },

        goToOwnFunnel: function(data) {
            if (data.isAccommodationPostBookingCoSearch) {
                isAccommodationPostBookingCoSearch = true;
            }
            trackingUtils.trackEvent('accommodation_postbooking_on_load', ' postbook_own_funnel');
            const params = this.getHSAParams(data.bookingDetailDTO);
            this.navigateToHSA(params);
        },

        getHSAParams: function(bookingDetailDTO) {
            const {itineraryBookings, travellers} = bookingDetailDTO;
            const {bookingItinerary, itinerarySegments} = itineraryBookings;
            const {tripType} = bookingItinerary;
            const email = bookingDetailDTO.buyer.mail || '';
            const creationDate = bookingDetailDTO.bookingBasicInfo.creationDate || '';
            const bookingId = bookingDetailDTO.bookingBasicInfo.id || 'NA';
            const [firstSegment] = itinerarySegments;
            const arrivalFlight = Odigeo._.last(firstSegment.sections).section;
            const {to, arrivalDate} = arrivalFlight;
            const buyPath = postBookingUtils.getBuyPathFromUrl();

            const checkIn = postBookingUtils.getCheckInDate(arrivalDate);
            const checkOut = postBookingUtils.getCheckOutDate(tripType, itinerarySegments, arrivalDate);
            const geoNodeId = to.geoNodeId;
            const postBookingId = postBookingUtils.getHashToHSA(email, creationDate, membershipRepository.isPrimeUser(), bookingId);
            const searchType = 'POST_BOOKING';
            const buyPathParam = buyPath ? `;buyPath=${buyPath}` : '';
            const roomsParam = postBookingUtils.getRoomsParam(travellers);

            return `checkIn=${checkIn};checkOut=${checkOut};geoNodeId=${geoNodeId};`
                +`postBookingId=${postBookingId};searchType=${searchType}${buyPathParam};${roomsParam}`;
        },

        navigateToHSA: function(params) {
            const protocol = location.protocol;
            const hostname = location.hostname;
            const locationPort = location.port ? `:${location.port}` : '';
            const path = '/travel/accommodation/hotel_results/';
            location.href = `${protocol}//${hostname}${locationPort}${path}${params}`;
        },

        goToWhiteLabel: function(data) {
            const {tripType} = data.bookingDetailDTO.itineraryBookings.bookingItinerary;
            if (linkExpiredFlag || tripType.substring(0, 5) === MULTI) {
                this.onWLRedirectionErrors();
            } else {
                this.redirectToWhiteLabel(data);
            }
        },

        redirectToWhiteLabel(data) {
            let urlLabel;
            let touchpoint;
            if (appContext.isExpediaMarket()) {
                const wapb3Param = Odigeo.Session.get('expediaTrackingParameterWapb3');
                urlLabel = `${wapb3Param}`;
                if (!Odigeo.CONFIG.shouldRedirectWhitelabelPrime) {
                    data.hasPrimeDiscount = false;
                } else if (data.isAccommodationPostBookingCoSearch && data.hasPrimeDiscount) {
                    urlLabel = replaceCIDForPrimeCID(urlLabel);
                }
                touchpoint = urlLabel.split('s.')[1] ?? '';
            } else {
                urlLabel = Odigeo.Session.get('bookingTrackingParameterLabel') || postBookingUtils.getBookingWLFallbackLabel();
                touchpoint = urlLabel;
            }

            xsellController.then(({default: module}) => {
                const xsellModule = module();
                xsellModule.setItinerary(data.bookingDetailDTO);
                return xsellModule.getHotelsDeepLink(touchpoint, data.hasPrimeDiscount);
            }).then((url) => {
                const postbookingHotelsDeeplink = (urlLabel === null || urlLabel === 'null') ? url : replaceHotelsLabelFromDeeplink(url, urlLabel);
                window.location.replace(postbookingHotelsDeeplink);
            });
        },
        onTripLoadError: function() {
            widgets.getPostBookingAccommodation().execute('error', 'no_booking_found');
            postBookingUtils.errorHotelsHomeRedirection();
        },
        trackErrorAndMessages: function(errors, type) {
            Odigeo._.each(errors, function(error) {
                if (!Odigeo._.isEmpty(error.code)) {
                    const trackingSufix = error.code === 'WNG-024' ? 'noresults' : error.code;
                    trackingUtils.trackEvent('intermediate_page_on_load', 'intermediate_page_not_shown_' + type + trackingSufix);
                }
            });
        },
        onWLRedirectionErrors: function() {
            window.location = postBookingUtils.getHotelsWhiteLabel();
        },
        onGetUserTypeResponseOk: function(userType) {
            const isPrimeByTravelCompanionResponse = travelCompanionResponse
                && travelCompanionResponse.bookingDetailDTO
                && travelCompanionResponse.bookingDetailDTO.prime;
            if (userType === PREMIUM || isPrimeByTravelCompanionResponse) {
                travelCompanionResponse.hasPrimeDiscount = true;
            }
            this.redirectToPostBookingFunnel(travelCompanionResponse);
            travelCompanionResponse = null;
        },
        onGetUserTypeResponseError: function() {
            travelCompanionResponse.hasPrimeDiscount = false;
            this.redirectToPostBookingFunnel(travelCompanionResponse);
            travelCompanionResponse = null;
        },
        onLaunchHomeCoSearch: function(parameters) {
            const params = {
                iata: parameters.iata,
                iata_orr: 1,
                checkin_monthday: Odigeo.Utils.formatDate(parameters.checkInDate, 'dd', true),
                checkin_year_month: Odigeo.Utils.formatDate(parameters.checkInDate, 'yyyy-mm', true),
                checkout_monthday: Odigeo.Utils.formatDate(parameters.checkOutDate, 'dd', true),
                checkout_year_month: Odigeo.Utils.formatDate(parameters.checkOutDate, 'yyyy-mm', true),
                selected_currency: appContext.getCurrencyCode(),
                lang: appContext.getLocale().split('_')[0],
                label: hotelLabels.getBookingTracking('sbextension-search-pc-of'),
                ...(Odigeo.CrossSelling.bookingcom.aid && {aid: Odigeo.CrossSelling.bookingcom.aid}),
            };
            const bookingUrl = deeplinkBuilder().withBaseUrl(Odigeo.CrossSelling.bookingcom.baseUrl).withQueryParams(params).build();
            window.location.replace(bookingUrl);
        },
    },

    showWaitingPage: function() {
        Odigeo.UIElements.enhanceLoading($waitingPages).showLoading(['waiting_post_booking_accommodation_intermediate']);
    },
};

function replaceHotelsLabelFromDeeplink(deeplink, label) {
    const deeplinkBaseUrl = deeplink.substring(0, deeplink.indexOf('?')+1);
    const deeplinkParams = deparamHotelsDeeplink(deeplink.substring(deeplink.indexOf('?')+1));

    Object.prototype.hasOwnProperty.call(deeplinkParams, 'label') ? deeplinkParams.label = label : deeplinkParams.wapb3 = label;
    return deeplinkBaseUrl + $.param(deeplinkParams);
}

function deparamHotelsDeeplink(deeplinkParams) {
    return Odigeo.Utils.parseJson(`{"${deeplinkParams.replace(/=/g, '":"').replace(/&/g, '","')}"}`);
}
